import { DEFAULT_BRANDING_COMPANY_NAME } from '@config/config';
import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a UUID (version 4) without hyphens.
 * @returns {string} A 32-character UUID string without hyphens.
 */
export function uuid(): string {
  return uuidv4().replace(/-/g, '');
}

export function toTitle(str: string): string {
  return str
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}

export const hasTextOverflow = (
  content: any,
  maxLength: number = 35,
): boolean => {
  if (Array.isArray(content)) {
    // Check first item length if array exists and has items
    return content.length > 0 && content[0].length > maxLength;
  }

  if (typeof content === 'string') {
    // Check string length
    return content.length > maxLength;
  }

  if (typeof content === 'object' && content !== null) {
    // Check first key-value pair if object has entries
    const entries = Object.entries(content);
    return (
      (entries.length > 0 && String(entries[0][1]).length > maxLength) ||
      entries.length > 1
    );
  }

  if (typeof content === 'boolean') {
    // Boolean values don't overflow
    return false;
  }

  return false;
};

export function trimBrTags(html: string): string {
  if (!html || typeof html !== 'string') return '';

  return html
    .replace(/^(<br\s*\/?>\s*)+/gi, '') // Trim from start
    .replace(/(<br\s*\/?>\s*)+$/gi, ''); // Trim from end
}

export function getCompanyFromUrl() {
  const url = window.location.origin;
  if (typeof window === 'undefined' || !url) {
    return DEFAULT_BRANDING_COMPANY_NAME;
  }

  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;

    if (hostname === 'localhost') {
      return DEFAULT_BRANDING_COMPANY_NAME;
    }

    const baseDomains = ['fibonaccipartner.com', 'leoads.ai', 'percuity.ai', 'amplifyapp.com'];
    const platformSubdomains = new Set([
      'leonardo', 'app', 'api', 'backoffice', 'demo', 'www',
      'dev', 'dev2', 'dev3', 'uat', 'prod', 'staging',
      'dev-api', 'dev2-api', 'dev3-api', 'uat-api', 'prod-api',
      'main', 'development', 'production', 'master',
    ]);

    let remaining = hostname;
    for (const base of baseDomains) {
      if (remaining.endsWith('.' + base)) {
        remaining = remaining.slice(0, -(base.length + 1));
        break;
      }
      if (remaining === base) {
        return DEFAULT_BRANDING_COMPANY_NAME;
      }
    }

    const parts = remaining.split('.').filter((p) => !platformSubdomains.has(p));

    if (parts.length > 0 && parts[0]) {
      console.log('[getCompanyFromUrl] Extracted company:', parts[0]);
      return parts[0];
    }

    return DEFAULT_BRANDING_COMPANY_NAME;
  } catch (error) {
    console.log('[getCompanyFromUrl] Error parsing URL, using default:', error);
    return DEFAULT_BRANDING_COMPANY_NAME;
  }
}
